import React, { Fragment } from 'react';
import { wrapOptionId } from '../../helpers/strings';
import { option as _option } from 'fp-ts';

const CircularImageSwatch = ({ labelProps, option, mediaUrl }) => {
  const isWhite = _option
    .fromNullable(option.label)
    .map(x => x.toLowerCase().includes('white'))
    .getOrElse(false);

  return (
    <Fragment>
      <label
        className="PDPRedesign--ControlElement"
        {...labelProps}
        htmlFor={wrapOptionId(option.id)}
      >
        <img
          alt={option.label}
          src={`${mediaUrl}attribute/swatch/swatch_image/56x56${option.display_label}?auto=webp`}
        />
      </label>
      <label
        className={`PDPRedesign--CircularImage-Swatch ${isWhite ? 'isWhite' : ''}`}
        {...labelProps}
        htmlFor={wrapOptionId(option.id)}
      >
        <img
          alt={option.label}
          src={`${mediaUrl}attribute/swatch/swatch_image/56x56${option.display_label}?auto=webp`}
        />
      </label>
    </Fragment>
  );
};

export default CircularImageSwatch;



// WEBPACK FOOTER //
// ./src/components/RadioInput/CircularImageSwatch.js